import {API_URL} from "./api";

export default function getMeetingsPath(selectedDate = null) {
    const date = selectedDate ? new Date(selectedDate) : new Date();
    const dateString = date.toISOString().split('T')[0];

    return `/meetings/?dry_run=false&old=false&date=${dateString}`;
}
